export const employeesColumns = [
  {
    id: 'estado', label: 'Estado', type: 'select', sortable: true, required: true, options: [
      { value: 'Activo', label: 'Activo' },
      { value: 'Inactivo', label: 'Inactivo' },
    ]
  },
  {
    id: 'planta', label: 'Planta', type: 'select', sortable: true, required: true,
    options: [] // Se llenarán dinámicamente desde el componente padre
  },
  {
    id: 'area', label: 'Área', type: 'select', sortable: true, required: true,
    options: [] // Se llenarán dinámicamente desde el componente padre
  },
  {
    id: 'centroCosto', label: 'Centro de Costos', type: 'select', sortable: true, required: true,
    options: [] // Se llenarán dinámicamente desde el componente padre
  },
  { id: 'cedula', label: 'Cédula', type: 'text', sortable: true, required: true },
  { id: 'nombre', label: 'Nombre', type: 'text', sortable: true, required: true },
  { id: 'apellido', label: 'Apellido', type: 'text', sortable: true, required: true },
];


export const columnsExcel = [
  { key: 'estado', header: 'Estado' },
  { key: 'planta.nombre', header: 'Planta' },
  { key: 'area.nombre', header: 'Área' },
  { key: 'centroCosto.nombre', header: 'Centro de Costos' },
  { key: 'cedula', header: 'Cédula' },
  { key: 'nombre', header: 'Nombre' },
  { key: 'apellido', header: 'Apellido' },
  { key: 'correo', header: 'Correo' },
  { key: 'celular', header: 'Celular' },
  { key: 'direccion', header: 'Direccion' },
  { key: 'fechaIngreso', header: 'Fecha Ingreso' },
  { key: 'rol', header: 'Rol' },
  { key: 'EPS', header: 'EPS' },
  { key: 'arl', header: 'ARL' },
]